class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('button[type="button"]');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (!details) return;

    if (details.hasAttribute('open')) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    let closestSearchDetails = event.target.closest('.header__search details');
    if (event.target.closest(".search-drawer-main")) return;
    if (!this.contains(event.target) || event.target.classList.contains('search-drawer-show') || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
    if(closestSearchDetails && event.target.classList.contains('search-drawer-show')){
      setTimeout(() => {
      closestSearchDetails.removeAttribute('open');
      }, 1000);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    const details = event.target.closest('details');
    if (details) {
      details.setAttribute('open', true);
    }

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const searchDrawer = document.body.querySelector(".search-drawer-show");
    if (searchDrawer) {
    const searchCloseIcon = searchDrawer.querySelector('.clustom_cls');
      searchDrawer.classList.add("active-search");
      if (searchCloseIcon) {
        searchCloseIcon.addEventListener('click', () => {
          this.close();
        });
     }
    }

    if (this.detailsContainer) {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    if (this.detailsContainer) {
       setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
       }, 500);
    }

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    const searchDrawer = document.body.querySelector(".search-drawer-show");
    if (searchDrawer) {
      searchDrawer.classList.remove("active-search");
    }
  }
}

customElements.define('details-modal', DetailsModal);
